import type { App as Application } from 'vue'
import APPS from '@/constants/apps'
import { useSpace } from '@/store/modules/App/space'
import { Permissions } from '@/types'

export default {
  install: function (app: Application): void {
    app.config.globalProperties.$hasTaskPermissions = function (): boolean {
      const spaceStore = useSpace()
      const isAdmin = spaceStore.isSpaceAdmin

      return (
        this.$isAppInstalled(APPS.tasks) &&
        (this.$can(Permissions.AccessTasks) ||
          this.$can(Permissions.CreateTasks) ||
          this.$can(Permissions.ExecuteTasks) ||
          this.$can(Permissions.EditTasks) ||
          this.$can(Permissions.DeleteTasks) ||
          isAdmin)
      )
    }
  },
}
